import React from "react";

interface IProps {
    size: "sm" | "md" | "lg";
}

export default function DinersClub(props: IProps) {
    const { size } = props;

    const SVGSize = {
        sm: "M18.4335 4.8007C22.4857 4.73771 25.7782 8.01542 25.8417 12.0497V12.1132C25.715 16.0846 22.4859 19.2997 18.4335 19.2997H15.8378C11.912 19.2367 8.74605 16.0216 8.74601 12.1132C8.61937 8.20475 11.6589 4.92678 15.5214 4.8007H18.4335ZM16.0273 6.06144C12.735 6.06164 10.0128 8.77197 10.0126 12.0497C10.0127 15.3276 12.7349 18.0388 16.0273 18.039C19.3198 18.0389 22.0428 15.3277 22.0429 12.0497C22.0426 8.77188 19.3197 6.06149 16.0273 6.06144ZM15.078 16.0849C12.862 15.5176 11.5319 13.2481 12.1015 11.0419C12.4814 9.592 13.6217 8.45726 15.078 8.07902V16.0849ZM16.9775 8.07902C19.1935 8.64641 20.5862 10.8522 20.0165 13.0585C19.6366 14.5715 18.4971 15.7066 16.9775 16.0849V8.07902Z",
        md: "M24.5783 6.40109C29.9814 6.31704 34.3716 10.688 34.4562 16.0671V16.1511C34.2874 21.4464 29.9816 25.7331 24.5783 25.7331H21.1174C15.8831 25.649 11.6613 21.3623 11.6613 16.1511C11.4928 10.9401 15.5458 6.56929 20.6955 6.40109H24.5783ZM21.3703 8.08274C16.9805 8.08294 13.35 11.6967 13.3498 16.0671C13.3498 20.4377 16.9803 24.0523 21.3703 24.0525C25.7604 24.0525 29.3908 20.4379 29.3908 16.0671C29.3906 11.6966 25.7603 8.08274 21.3703 8.08274ZM20.1037 21.447C17.149 20.6904 15.3761 17.6641 16.1359 14.7224C16.6425 12.7893 18.1621 11.2766 20.1037 10.7722V21.447ZM22.6369 10.7722C25.5916 11.5287 27.4492 14.4702 26.6896 17.4118C26.1831 19.4291 24.6631 20.9427 22.6369 21.447V10.7722Z",
        lg: "M30.7241 8.00198C37.4782 7.89691 42.9662 13.3598 43.0718 20.084V20.1895C42.8606 26.8085 37.4781 32.167 30.7241 32.167H26.398C19.8551 32.062 14.5788 26.7034 14.5786 20.1895C14.3676 13.6755 19.4324 8.21235 25.8696 8.00198H30.7241ZM26.7144 10.1026C21.2267 10.1026 16.689 14.6206 16.689 20.084C16.689 25.5474 21.2267 30.0655 26.7144 30.0655C32.202 30.0654 36.7398 25.5474 36.7398 20.084C36.7397 14.6206 32.202 10.1026 26.7144 10.1026ZM25.1314 26.8086C21.4378 25.8631 19.2218 22.0806 20.1714 18.4033C20.8046 15.9868 22.7041 14.0953 25.1314 13.4649V26.8086ZM28.2974 13.4649C31.9908 14.4104 34.3123 18.0875 33.3628 21.7647C32.7296 24.2863 30.8301 26.1782 28.2974 26.8086V13.4649Z",
    };

    const width = {
        sm: 34,
        md: 46,
        lg: 58,
    };

    const height = {
        sm: 24,
        md: 32,
        lg: 40,
    };

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width[size]} height={height[size]} viewBox={`0 0 ${width[size]} ${height[size]}`} fill="none">
            <rect x="0.5" y="0.5" width={width[size] - 1} height={height[size] - 1} rx="3.5" fill="white"/>
            <rect x="0.5" y="0.5" width={width[size] - 1} height={height[size] - 1} rx="3.5" stroke="#F2F4F7"/>
            <path d={SVGSize[size]} fill="#0079BE"/>
        </svg>
    );
}